import Alea from 'aleaprng'
import { nanoid } from 'nanoid'

const rand = Alea(nanoid())

export function randomElement(array) {
    return array[rand.range(array.length - 1)]
}
